import Z, { jsxs as $, jsx as v } from "react/jsx-runtime";
import * as a from "react";
import { useState as ee } from "react";
import { l as te, a as E, m as B, c as ne, _ as re, C as oe, o as ie } from "./createTheme-feb5b756.js";
import { T as q, P as l } from "./identifier-6f4bda5a.js";
import { useThemeProps as se, createStyled as ue, shouldForwardProp as le } from "@mui/system";
import { Unstable_Grid2 as b, Typography as ae } from "@mui/material";
import { makeStyles as ce } from "@mui/styles";
import { a as fe } from "./SearchInput-8b2bd2f9.js";
function T(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : te(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function de(...e) {
  return e.reduce((t, n) => n == null ? t : function(...o) {
    t.apply(this, o), n.apply(this, o);
  }, () => {
  });
}
function pe(e, t = 166) {
  let n;
  function r(...o) {
    const i = () => {
      e.apply(this, o);
    };
    clearTimeout(n), n = setTimeout(i, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function me(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : (n, r, o, i, s) => {
    const u = o || "<<anonymous>>", c = s || r;
    return typeof n[r] < "u" ? new Error(`The ${i} \`${c}\` of \`${u}\` is deprecated. ${t}`) : null;
  };
}
function he(e, t) {
  var n, r;
  return /* @__PURE__ */ a.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (n = e.type.muiName) != null ? n : (r = e.type) == null || (r = r._payload) == null || (r = r.value) == null ? void 0 : r.muiName
  ) !== -1;
}
function k(e) {
  return e && e.ownerDocument || document;
}
function ge(e) {
  return k(e).defaultView || window;
}
function ye(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? E({}, t.propTypes) : null;
  return (o) => (i, s, u, c, f, ...d) => {
    const m = f || s, p = n == null ? void 0 : n[m];
    if (p) {
      const h = p(i, s, u, c, f, ...d);
      if (h)
        return h;
    }
    return typeof i[s] < "u" && !i[o] ? new Error(`The prop \`${m}\` of \`${e}\` can only be used together with the \`${o}\` prop.`) : null;
  };
}
function G(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const ve = typeof window < "u" ? a.useLayoutEffect : a.useEffect, K = ve;
let L = 0;
function Se(e) {
  const [t, n] = a.useState(e), r = e || t;
  return a.useEffect(() => {
    t == null && (L += 1, n(`mui-${L}`));
  }, [t]), r;
}
const M = a["useId".toString()];
function Te(e) {
  if (M !== void 0) {
    const t = M();
    return e ?? t;
  }
  return Se(e);
}
function _e(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = o || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function Ie({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = a.useRef(e !== void 0), [i, s] = a.useState(t), u = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    a.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: f
    } = a.useRef(t);
    a.useEffect(() => {
      !o && f !== t && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = a.useCallback((f) => {
    o || s(f);
  }, []);
  return [u, c];
}
function Ee(e) {
  const t = a.useRef(e);
  return K(() => {
    t.current = e;
  }), a.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function Ne(...e) {
  return a.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      G(n, t);
    });
  }, e);
}
class A {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new A();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
let N = !0, R = !1;
const be = new A(), we = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function Oe(e) {
  const {
    type: t,
    tagName: n
  } = e;
  return !!(n === "INPUT" && we[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function $e(e) {
  e.metaKey || e.altKey || e.ctrlKey || (N = !0);
}
function w() {
  N = !1;
}
function Re() {
  this.visibilityState === "hidden" && R && (N = !0);
}
function Ae(e) {
  e.addEventListener("keydown", $e, !0), e.addEventListener("mousedown", w, !0), e.addEventListener("pointerdown", w, !0), e.addEventListener("touchstart", w, !0), e.addEventListener("visibilitychange", Re, !0);
}
function Pe(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return N || Oe(t);
}
function xe() {
  const e = a.useCallback((o) => {
    o != null && Ae(o.ownerDocument);
  }, []), t = a.useRef(!1);
  function n() {
    return t.current ? (R = !0, be.start(100, () => {
      R = !1;
    }), t.current = !1, !0) : !1;
  }
  function r(o) {
    return Pe(o) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: r,
    onBlur: n,
    ref: e
  };
}
function Ce(e, t, n = void 0) {
  const r = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      r[o] = e[o].reduce((i, s) => {
        if (s) {
          const u = t(s);
          u !== "" && i.push(u), n && n[s] && i.push(n[s]);
        }
        return i;
      }, []).join(" ");
    }
  ), r;
}
function De(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = B(e, o, n);
  }), r;
}
const Le = ne(), J = Le;
function Me({
  props: e,
  name: t
}) {
  return se({
    props: e,
    name: t,
    defaultTheme: J,
    themeId: q
  });
}
const Ve = (e) => le(e) && e !== "classes", Ue = ue({
  themeId: q,
  defaultTheme: J,
  rootShouldForwardProp: Ve
}), je = Ue;
var H = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(H);
var ze = H.exports, O = {};
function W(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = W(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function Fe() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = W(e)) && (r && (r += " "), r += t);
  return r;
}
function Be(e) {
  return B("MuiSvgIcon", e);
}
De("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const qe = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], ke = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, o = {
    root: ["root", t !== "inherit" && `color${T(t)}`, `fontSize${T(n)}`]
  };
  return Ce(o, Be, r);
}, Ge = je("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${T(n.color)}`], t[`fontSize${T(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, r, o, i, s, u, c, f, d, m, p, h, g;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // e.g. heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (n = e.transitions) == null || (r = n.create) == null ? void 0 : r.call(n, "fill", {
      duration: (o = e.transitions) == null || (o = o.duration) == null ? void 0 : o.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((i = e.typography) == null || (s = i.pxToRem) == null ? void 0 : s.call(i, 20)) || "1.25rem",
      medium: ((u = e.typography) == null || (c = u.pxToRem) == null ? void 0 : c.call(u, 24)) || "1.5rem",
      large: ((f = e.typography) == null || (d = f.pxToRem) == null ? void 0 : d.call(f, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (m = (p = (e.vars || e).palette) == null || (p = p[t.color]) == null ? void 0 : p.main) != null ? m : {
      action: (h = (e.vars || e).palette) == null || (h = h.action) == null ? void 0 : h.active,
      disabled: (g = (e.vars || e).palette) == null || (g = g.action) == null ? void 0 : g.disabled,
      inherit: void 0
    }[t.color]
  };
}), P = /* @__PURE__ */ a.forwardRef(function(t, n) {
  const r = Me({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: i,
    color: s = "inherit",
    component: u = "svg",
    fontSize: c = "medium",
    htmlColor: f,
    inheritViewBox: d = !1,
    titleAccess: m,
    viewBox: p = "0 0 24 24"
  } = r, h = re(r, qe), g = /* @__PURE__ */ a.isValidElement(o) && o.type === "svg", _ = E({}, r, {
    color: s,
    component: u,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: d,
    viewBox: p,
    hasSvgAsChild: g
  }), D = {};
  d || (D.viewBox = p);
  const Q = ke(_);
  return /* @__PURE__ */ $(Ge, E({
    as: u,
    className: Fe(Q.root, i),
    focusable: "false",
    color: f,
    "aria-hidden": m ? void 0 : !0,
    role: m ? "img" : void 0,
    ref: n
  }, D, h, g && o.props, {
    ownerState: _,
    children: [g ? o.props.children : o, m ? /* @__PURE__ */ v("title", {
      children: m
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (P.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: l.oneOfType([l.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: l.oneOfType([l.oneOf(["inherit", "large", "medium", "small"]), l.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: l.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: l.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: l.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: l.string
});
P.muiName = "SvgIcon";
const V = P;
function Ke(e, t) {
  function n(r, o) {
    return /* @__PURE__ */ v(V, E({
      "data-testid": `${t}Icon`,
      ref: o
    }, r, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = V.muiName, /* @__PURE__ */ a.memo(/* @__PURE__ */ a.forwardRef(n));
}
const Je = {
  configure: (e) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), oe.configure(e);
  }
}, He = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: T,
  createChainedFunction: de,
  createSvgIcon: Ke,
  debounce: pe,
  deprecatedPropType: me,
  isMuiElement: he,
  ownerDocument: k,
  ownerWindow: ge,
  requirePropFactory: ye,
  setRef: G,
  unstable_ClassNameGenerator: Je,
  unstable_useEnhancedEffect: K,
  unstable_useId: Te,
  unsupportedProp: _e,
  useControlled: Ie,
  useEventCallback: Ee,
  useForkRef: Ne,
  useIsFocusVisible: xe
}, Symbol.toStringTag, { value: "Module" })), We = /* @__PURE__ */ ie(He);
var U;
function Ye() {
  return U || (U = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = We;
  }(O)), O;
}
var x = {}, Xe = ze;
Object.defineProperty(x, "__esModule", {
  value: !0
});
var Y = x.default = void 0, Qe = Xe(Ye()), Ze = Z, et = (0, Qe.default)(/* @__PURE__ */ (0, Ze.jsx)("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), "LocationOn");
Y = x.default = et;
const j = {
  LATITUDE: 28.4595,
  LONGITUDE: 77.0266
}, z = "point_of_interest", y = {
  ESTABLISHMENT: "establishment",
  TRAIN_STATION: "train_station",
  TRANSIT_STATION: "transit_station",
  BUS_STATION: "bus_station",
  AIRPORT: "airport",
  RAIL: "rail"
}, X = 5e4, I = { current: null }, S = { current: null }, tt = ce((e) => ({
  icon: {
    color: e.palette.text.secondary,
    marginRight: e.spacing(2)
  }
})), F = {
  airport: y.AIRPORT,
  rail: y.TRAIN_STATION,
  bus: y.BUS_STATION
};
function nt() {
  return window.google && (I.current || (I.current = new window.google.maps.places.AutocompleteService())), !!I.current;
}
function rt(e) {
  return e ? e.map((t) => {
    const { id: n, description: r, place_id: o, structured_formatting: i } = t;
    return {
      id: n,
      structured_formatting: i,
      place: r,
      placeId: o
    };
  }) : [];
}
function ot(e) {
  return e.map((t) => {
    const { id: n, name: r, vicinity: o, place_id: i, geometry: s } = t;
    return {
      id: n,
      name: r,
      vicinity: o,
      geometry: s,
      placeId: i,
      structured_formatting: {
        main_text: r,
        secondary_text: o
      }
    };
  });
}
function it(e, t) {
  let n = e;
  return t === y.AIRPORT && (n = e.filter((o) => JSON.stringify([
    y.AIRPORT,
    y.ESTABLISHMENT,
    z
  ]) === JSON.stringify(o.types.sort()))), t === y.RAIL && (n = e.filter((o) => JSON.stringify([
    y.ESTABLISHMENT,
    y.TRAIN_STATION,
    y.TRANSIT_STATION,
    z
  ]) === JSON.stringify(o.types.sort()))), n.map((o) => {
    const { id: i, name: s, place_id: u, geometry: c } = o;
    return {
      id: i,
      name: s,
      placeId: u,
      lat: c.location.lat(),
      lng: c.location.lng()
    };
  });
}
function C() {
  return window.google && (S.current || (S.current = new window.google.maps.places.PlacesService(
    document.createElement("div")
  ))), !!S.current;
}
function ht(e) {
  const t = tt(), [n, r] = ee(null);
  function o(u) {
    return nt() ? new Promise((f) => {
      I.current.getPlacePredictions(
        { input: u },
        (d) => f(rt(d))
      );
    }) : Promise.resolve([]);
  }
  function i(u) {
    const {
      currentLocation: {
        lat: c = j.LATITUDE,
        lng: f = j.LONGITUDE
      },
      radius: d = X
    } = e;
    if (!C())
      return Promise.resolve([]);
    const p = {
      radius: d,
      location: new window.google.maps.LatLng(c, f),
      keyword: u
    };
    return new Promise(
      (h) => S.current.nearbySearch(
        p,
        (g) => h(ot(g))
      )
    );
  }
  function s(u, c, f) {
    const { inputValue: d } = f, { main_text: m, secondary_text: p } = c.structured_formatting, h = fe(m, d);
    return /* @__PURE__ */ v("div", { ...u, children: /* @__PURE__ */ $(b, { container: !0, alignItems: "center", children: [
      /* @__PURE__ */ v(b, { children: /* @__PURE__ */ v(Y, { className: t.icon }) }),
      /* @__PURE__ */ $(b, { xs: !0, children: [
        h.map((g, _) => /* @__PURE__ */ v(
          "span",
          {
            className: `${g.highlight ? "font-bold" : "font-normal"} whitespace-pre`,
            children: g.text
          },
          _
        )),
        p && /* @__PURE__ */ v(ae, { variant: "body2", color: "textSecondary", children: p })
      ] })
    ] }) });
  }
  return {
    value: n,
    onChange: r,
    fetchOptions: e ? i : o,
    renderOption: s,
    labelField: "place"
  };
}
function st(e) {
  var i, s;
  const { formatted_address: t, geometry: n, id: r, place_id: o } = e ?? {};
  return {
    id: r,
    placeId: o,
    place: t,
    lat: (i = n == null ? void 0 : n.location) == null ? void 0 : i.lat(),
    lng: (s = n == null ? void 0 : n.location) == null ? void 0 : s.lng()
  };
}
function gt(e) {
  return C() ? new Promise((n) => {
    S.current.getDetails(
      { placeId: e.placeId },
      (r) => n(st(r))
    );
  }) : Promise.resolve(null);
}
function yt(e) {
  if (!C())
    return Promise.resolve(null);
  const { lat: n, lng: r, type: o, keyword: i, radius: s = X } = e, c = {
    location: new window.google.maps.LatLng(n, r),
    radius: s,
    type: F[o],
    keyword: i
  };
  return new Promise((f) => {
    S.current.nearbySearch(
      c,
      (d) => f(it(d, F[o]))
    );
  });
}
export {
  j as D,
  yt as f,
  gt as g,
  ze as i,
  Ye as r,
  ht as u
};
//# sourceMappingURL=utils.entry-215e4034.js.map
